@if (active()) {
  <div
    [attr.aria-labelledby]="`tab__pill-${tabIndex()}`"
    class="tab"
    role="tabpanel"
  >
    {{ body() }}
    <ng-content />
  </div>
}
